module.exports = __webpack_public_path__ + "img/1562030986.18598d27.jpg";